import React, { Fragment, useEffect } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Switch from '@material-ui/core/Switch';
import ACL from "../common/utilities/ACL"
import Action from "./Redux/Actions"
import AdminDashboardLayout from "./layout"
import PropTypes from 'prop-types';
import {  makeStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';
import apiConfig from "../../common/apiConfig";



function descendingComparator(a, b, orderBy) {
if (b[orderBy] < a[orderBy]) {
	return -1;
}
if (b[orderBy] > a[orderBy]) {
	return 1;
}
return 0;
}

function getComparator(order, orderBy) {
return order === 'desc'
	? (a, b) => descendingComparator(a, b, orderBy)
	: (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
	const stabilizedThis = array.map((el, index) => [el, index]);
	stabilizedThis.sort((a, b) => {
		const order = comparator(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	});
	return stabilizedThis.map((el) => el[0]);
}

const headCells = [
	{ id: 'name', numeric: false, disablePadding: true, label: 'Name' },
	{ id: 'email', numeric: true, disablePadding: false, label: 'Email' },
	{ id: 'stores', numeric: true, disablePadding: false, label: 'Stores' },
	{ id: 'is_admin', numeric: true, disablePadding: false, label: 'Admin' },
];

function EnhancedTableHead(props) {
	const { classes, order, orderBy, numSelected, rowCount, onRequestSort } = props;
	const createSortHandler = (property) => (event) => {
		onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow>
				{headCells.map((headCell) => (
				<TableCell
					key={headCell.id}
					align={headCell.numeric ? 'right' : 'left'}
					// padding={headCell.disablePadding ? 'none' : 'default'}
					style={{ paddingLeft: "1em" }}
					sortDirection={orderBy === headCell.id ? order : false}
				>
					<TableSortLabel
						active={orderBy === headCell.id}
						direction={orderBy === headCell.id ? order : 'asc'}
						onClick={createSortHandler(headCell.id)}
					>
						{headCell.label}
						{orderBy === headCell.id ? (
							<span className={classes.visuallyHidden}>
								{order === 'desc' ? 'sorted descending' : 'sorted ascending'}
							</span>
						) : null}
					</TableSortLabel>
				</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

EnhancedTableHead.propTypes = {
	classes: PropTypes.object.isRequired,
	numSelected: PropTypes.number.isRequired,
	onRequestSort: PropTypes.func.isRequired,
	order: PropTypes.oneOf(['asc', 'desc']).isRequired,
	orderBy: PropTypes.string.isRequired,
	rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
	},
	paper: {
		width: '100%',
		marginBottom: theme.spacing(2),
	},
	tableContainer: {
		overflowX: "auto"
	},
	table: {
		// minWidth: 750
	},
	visuallyHidden: {
		border: 0,
		clip: 'rect(0 0 0 0)',
		height: 1,
		margin: -1,
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		top: 20,
		width: 1,
	},
	noResult: {
		width: "100%",
		display: "block",
		textAlign: "center",
		padding: "2em"
	}
}));

function EnhancedTable(props) {
	const classes = useStyles();
	const [order, setOrder] = React.useState('asc');
	const [orderBy, setOrderBy] = React.useState('calories');
	const [selected, setSelected] = React.useState([]);
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);
	const [userList, setUserList] = React.useState(props.userList);

	useEffect(() => {
		setUserList(props.userList);
	  }, [props.userList]);

	const handleRequestSort = (event, property) => {
		const isAsc = orderBy === property && order === 'asc';
		setOrder(isAsc ? 'desc' : 'asc');
		setOrderBy(property);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	return (
		userList.length ?
		<Fragment>
			<div className={classes.tableContainer}>
				<Table
					className={classes.table}
					aria-labelledby="tableTitle"
					size={'medium'}
					aria-label="enhanced table"
				>
					<EnhancedTableHead
						classes={classes}
						numSelected={selected.length}
						order={order}
						orderBy={orderBy}
						onRequestSort={handleRequestSort}
						rowCount={userList.length}
					/>
					<TableBody>
						{stableSort(userList, getComparator(order, orderBy))
						.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
						.map((row, index) => {
							const labelId = `enhanced-table-checkbox-${index}`;

							return (
								<TableRow
									key={row.email}
									hover
									// onClick={(event) => handleClick(event, row.first_name + " " + row.last_name)}
									role="checkbox"
									tabIndex={-1}
								>
									<TableCell component="th" id={labelId} scope="row"
										style={{ marginLeft: "1em"}}
									>	
										{ row.is_superuser ?
											<Badge color="primary" badgeContent={"SU"}>
												<Typography>{ `${row.first_name} ${row.last_name}` }</Typography>
											</Badge>
											:
											`${row.first_name} ${row.last_name}`
										}
									</TableCell>
									<TableCell align="right">{row.email}</TableCell>
									<TableCell align="right">
										{row.stores.map((shop) => (
											<a key={shop.site} href={`${apiConfig.localHost}shop/${shop.site}`} target="_blank">
												{shop.name}
											</a>
										))}
									</TableCell>
									<TableCell align="right">
										<Switch
											name={row.email}
											checked={row.is_admin}
											onChange={props.setPermission}
											color="primary"
											inputProps={{ 'aria-label': 'primary checkbox' }}
										/>
									</TableCell>
								</TableRow>
							);
						})}
					</TableBody>
				</Table>
			</div>
			<TablePagination
				rowsPerPageOptions={[5, 10, 25]}
				component="div"
				count={userList.length}
				rowsPerPage={rowsPerPage}
				page={page}
				onChangePage={handleChangePage}
				onChangeRowsPerPage={handleChangeRowsPerPage}
			/>
		</Fragment>
		:
		<div className={classes.noResult}>Nothing to Show</div>
	);
}

const permissionStyles = theme => ({
	paper: {
		overflow: "hidden",
		padding: theme.spacing(2),
		color: theme.palette.text.secondary,
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(1),
		},
	},
	card: {
		backgroundColor: "white",
		padding: 0
	},
	cardHeader: {
		fontSize: "28px",
		marginBottom: "0.5em",
		textAlign: "left",
		color: "#F97663",
		fontWeight: 600
	},
	textDivider: {
		fontSize: "16px",
		padding: "1.5em 0",
		marginBottom: 0
	},
	miniCardHeader: {
		fontSize: "16px",
		textAlign: 'left',
		color: "#F97663",
		paddingBottom: "0.5em",
		[theme.breakpoints.down("sm")]: {
			fontSize: "14px",
		},
	},
	miniCardBody: {
		fontSize: "28px",
		weight: "bold",
		textAlign: 'left',
		color: theme.palette.text.primary,
	},
	lineChart: {
		paddingLeft: "auto",
		paddingRight: "auto",
		paddingTop: "2em",
		position: "relative",
		height: "400px",
		width: "100%",
		display: "block"
	},
	headerButtons: {
		height: "35px"
	},
	pageHeader: {
		display: "flex",
		padding: "1.5em",
		alignItems: "center",
		fontWeight: 600,
		boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.2)",
		[theme.breakpoints.down("xs")]: {
			display: "block",
			padding: "1em",
			marginTop: "1em"
		},

	},
	pageTitle: {
		fontSize: 18, 
		fontWeight: 600,
		marginBottom: 0,
		[theme.breakpoints.down("sm")]: {
			marginBottom: "0.7em",
			display: "none"
		},
	},
	searchInputWrapper: {
		display: "flex"
	},
	searchInput: {
		flexGrow: 1
	},
	tableWrapper: {
		overflowX: "auto"
	}
});


function IsInArray(array, lookup){
	if(array.length){
		for(let i in array){
			if (array[i].name.toLowerCase().indexOf(lookup) != -1){
				return true
			}
		}
	}
	return false
}

class Permissions extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			usersList: [],
			filteredList: []
		};
		this.onSearch = this.onSearch.bind(this)
		this.setPermission = this.setPermission.bind(this)
	}
	
	onSearch(event) {
		const val = event.target.value
		let result = this.state.usersList.filter(user => {
			const lowerCaseQueryStr = val.toLowerCase()
			return (
					user.email.toLowerCase().indexOf(lowerCaseQueryStr) != -1 || 
					lowerCaseQueryStr.indexOf(user.first_name.toLowerCase()) != -1 ||
					lowerCaseQueryStr.indexOf(user.last_name.toLowerCase()) != -1 || 
					user.created_on.toLowerCase().indexOf(lowerCaseQueryStr) != -1 ||
					IsInArray(user.stores, lowerCaseQueryStr)
				)
			});
		this.setState({
			filteredList: result
		})
	}

	setPermission(event) {
		const { dispatch } = this.props
		const email = event.target.name
		const is_checked = event.target.checked
		dispatch(Action.setUserPermission(email, is_checked));

		const list = this.state.filteredList.map((user) => {
			if (user.email === email) {
				user.is_admin = is_checked
				return user
			} else {
			  return user;
			}
		});
		this.setState({
			filteredList: list
		});
	}

	componentDidMount(){
		const { dispatch, login } = this.props
		dispatch(Action.fetchUsers())
	}

	componentWillReceiveProps(nextProps){
		if (nextProps.adminDashboard.usersList.length){
			this.setState({
				usersList: nextProps.adminDashboard.usersList,
				filteredList: nextProps.adminDashboard.usersList
			})
		}
	}
	
	render (){
		const {
			filteredList
		} = this.state
		const { classes, adminDashboard } = this.props
		return (
			<AdminDashboardLayout>
				<ACL roles={["superuser"]} redirect_to="/admin/dashboard">
					<div className={classes.pageHeader}>
						<p className={classes.pageTitle}>
							User Permissions
						</p>
						<div style={{marginLeft: "auto"}}>
							<div className={classes.searchInputWrapper} component="form">
								<InputBase
									className={classes.searchInput}
									placeholder="Search Users"
									inputProps={{ 'aria-label': 'search users' }}
									onChange={this.onSearch}
								/>
								<IconButton type="submit" className={classes.iconButton} aria-label="search">
									<SearchIcon />
								</IconButton>
							</div>
						</div>
					</div>
					<div style={{ padding: "1.5em"}}>
						{ 
							adminDashboard.error ?
							"" :
							<Paper className={classes.card}>
								<EnhancedTable userList={filteredList} setPermission={this.setPermission}/>
							</Paper>
						}
					</div>
				</ACL>
			</AdminDashboardLayout>
		);
	}
}

const mapStateToProps = state => ({ adminDashboard }) => ({ adminDashboard });
export default connect(mapStateToProps)(withStyles(permissionStyles)(Permissions))